<template>
    <validation class="form-group" :class="{ hasError: hasErrors, hasSuccess: isValid }"  :validator="v" :name="name" :inputclass="inputclass">
        <label v-if="label != ''"><span v-html="label"></span> <sup v-if="isRequired" class="text-danger">*</sup></label>
        
        <div>
            <input type="text" :name="name" style="display:none" v-model.trim="data" :disabled='isLoading' autocomplete="no">
            <a href="javascript:void(0)" class="btn  btn-sm rounded rounded-round btn-rounded " v-bind:class="[data === true ? 'btn-success' : 'btn-light']" :disabled='isLoading' @click="data = true">YES</a>
            <a href="javascript:void(0)" class="btn btn-sm rounded rounded-round btn-rounded ml-2 " v-bind:class="[data === false ? 'btn-success' : 'btn-light']" :disabled='isLoading' @click="data = false">NO</a>
        </div>

        <div v-if="verr[0]" class="form-text errors text-danger">{{verr[0]}}</div>
    </validation>
</template>

<script>

import { singleErrorExtractorMixin } from "vuelidate-error-extractor";

export default {
    mixins: [singleErrorExtractorMixin],
    props: {
        value: {
            type: [String, Number, Boolean],
            default: ""
        },
        name: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            default: ""
        },
        inputclass :{
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        v: {
            type: Object,
            required: true
        },
        isLoading : {
            type: Boolean,
            default: false
        },
        isRequired : {
            type: Boolean,
            default: false
        },
        verr : {
            type: Array,
            default: []
        }
    },
    computed: {
        data: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            }
    }
}
};
</script>